import React, { useState, useEffect } from "react";
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { Tabs, Tab } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Input,
  Label,
  Spinner,
} from "reactstrap";
import { MDBDataTableV5 } from "mdbreact";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import { BASE_URL } from "utils/constants";
import { Link, useParams } from "react-router-dom";

const examLink = "";

const CourseGrading = () => {
  let qzs = [],
    hws = [],
    examsFromScho = [];

  const [examsData, setExamsData] = useState({
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Due",
          field: "ddate",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Score",
          field: "score",
        },
        {
          label: "Out Of",
          field: "outof",
        },
        {
          label: "Preview",
          field: "preview",
        },
      ],
      rows: [
        {
          name: (
            <>
              <Spinner color="info" />
            </>
          ),
          ddate: "",
          status: "",
          score: "",
          outof: "",
          preview: <></>,
        },
      ],
    }),
    [course, setCourse] = useState({}),
    [totScores, setTotScores] = useState(0),
    [totMarks, setTotMarks] = useState(0),
    { id } = useParams(),
    mySwal = withReactContent(Swal);
  const sectionContent = (html) => {
    return <div dangerouslySetInnerHTML={{ __html: html }}></div>;
  };
  const handleExamStatistics = () => {
    mySwal.fire({
      html: (
        <>
          <ul className="fs-6 fw-bold w-100 mb-5 list-unstyled">
            <li>Low : 15</li>
            <li>Mean : 20</li>
            <li>High : 25</li>
          </ul>
        </>
      ),
      title: "Exam Statistics",
      icon: "info",
      iconHtml: "!",
      showConfirmButton: false,
    });
  };

  const getSchGrades = (originArr) => {
    let grdsArr = [];
    let cIndex = 0;
    originArr.forEach((section) => {
      const catArray = section["grading_category"];
      section["period"]?.forEach((period) => {
        period["assignment"]?.forEach((ass) => {
          cIndex = catArray?.findIndex((gc) => gc.id == ass.category_id);
         
          ass["category"] =
            cIndex != -1 ? catArray[cIndex].title : "Assessment";
          grdsArr.push(ass);
        });
      });
    });
    return grdsArr;
  };

  useEffect(() => {
    (async () => {
      try {
        
        let res = await axios.post(`${BASE_URL}/student/getcourse.php`, {
          id: id,
        });
        setCourse(res.data.data);
       
      } catch {
        Swal.fire("Error while grapping exams!", "", "error");
      }
    })();
  }, []);

  const getcourseGrades = ()=>{

    Swal.showLoading();
    axios
      .post(`${BASE_URL}/exam/getcoursegrades.php` , {course_id :id})
      .then((res) => {
      
       
        let exams = [],
          exOfSchoology = [];
        qzs =
          res.data.data?.quizez?.length > 0
            ? res.data.data?.quizez?.filter(
                (exam) =>
                  exam.subject_id == id &&
                  (exam.status == "Graded" || exam.status == "Missed")
              )
            : [];
        hws =
          res.data.data?.homeworks > 0
            ? res.data.data?.homeworks?.filter(
                (exam) =>
                  exam.subject_id == id &&
                  (exam.status == "Graded" || exam.status == "Missed")
              )
            : [];
        examsFromScho =
          res.data.data?.courses?.length > 0
            ? res.data.data?.courses?.filter((course) => course.id == id)[0]
                .sectionsArray
            : [];
        if (qzs && hws) {
          exams = qzs.concat(hws);
        } else if (qzs) {
          exams = qzs;
        } else {
          exams = hws;
        }

        
        if (examsFromScho?.length > 0) {
          exOfSchoology = getSchGrades(examsFromScho)?.filter(
            (ex) => ex.grade != null
          );
        }
        
        // set home works datatable
        if (exams?.length > 0 || exOfSchoology?.length > 0) {
          setExamsData((prevState) => {
            const newState = { ...prevState };
            // let ser = 1;
            let score = 0,
              totalMark = 0,
              ArrayQuestions = [],
              ArrayGraded = [],
              totalMarks = 0,
              totalScores = 0;
            // change .exams below to .homeworks after backend finished
            let newRows = exams?.map((exam, key) => {
              ArrayQuestions = JSON.parse(exam.questions);
              ArrayGraded = JSON.parse(exam.answerdquestions);
              score =
                exam.status == "Graded"
                  ? ArrayGraded?.reduce((total, obj) => +obj.score + total, 0)
                  : 0;
              totalMark = ArrayQuestions?.reduce(
                (total, obj) => +obj.totalMark + total,
                0
              );
              totalScores += score;
              totalMarks += totalMark;
              setTotScores(totalScores);
              setTotMarks(totalMarks);
              return {
                ...exam,
                name: (
                  <>
                    {exam.examname}
                    <br />
                    <small className="fw-bold text-danger">{exam.type}</small>
                  </>
                ),
                ddate: exam.enddate,
                status: exam.status,
                score: score,
                outof: totalMark,
                preview: (
                  <>
                    <a
                      href={exam.examlink}
                      target="_blank"
                      className="btn btn-primary text-center fs-6 fw-bold py-1 px-3"
                    >
                      Preview
                    </a>
                    <a
                      className="ms-3"
                      style={{ textDecoration: "none" }}
                      onClick={() => handleExamStatistics()}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="currentColor"
                        class="bi bi-info-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                      </svg>
                    </a>
                  </>
                ),
              };
            });
            let newRows2 = exOfSchoology?.map((exam, key) => {
              score = exam.grade;
              totalMark = exam.max_points;
              totalScores += score;
              totalMarks += totalMark;
              setTotScores(totalScores);
              setTotMarks(totalMarks);
              return {
                ...exam,
                name: (
                  <>
                    {exam.category}
                    <br />
                    <small className="fw-bold text-danger">{exam.type}</small>
                  </>
                ),
                ddate: new Date(exam.timestamp * 1000)?.toLocaleString(),
                status: "Graded",
                score: score,
                outof: totalMark,
              };
            });
            let totalRows = newRows?.concat(newRows2);
            if (totalRows.length === 0) {
              totalRows = [];
            }
            return { ...newState, rows: totalRows ?? [] };
          });
        }
        
        Swal.close();

      })
      .catch((e) => {
        Swal.fire("Error while grapping exams!", "", "error");
      })
      .finally(() => {
        Swal.close();
      });
  }
useEffect(() => {

  getcourseGrades();
},[])
  const ControlledTabs = () => {
    const [key, setKey] = useState("intro");
    if (key === "grades") {
     
    }
    return (
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3 text-center w-100 justify-content-center align-items-center fw-bold p-0"
        style={{ fontSize: "10pt", maxWidth: "100%" }}
      >
        <Tab eventKey="home" title="Home" style={{ maxWidth: "100%" }}>
          <div className="pt-5">
            {course?.coursedescription ? (
              sectionContent(course?.coursedescription)
            ) : (
              <h3>"NA" </h3>
            )}
          </div>
        </Tab>
        <Tab
          eventKey="announcements"
          title="Announcements"
          style={{ maxWidth: "100%" }}
        >
          <div className="text-left pt-5 mt-5"></div>
        </Tab>
        <Tab eventKey="syllabus" title="Syllabus" style={{ maxWidth: "100%" }}>
          <div className="text-center pt-5">
            <h3>
              {course?.coursesyllubus
                ? sectionContent(course?.coursesyllubus)
                : "NA"}
            </h3>
          </div>
        </Tab>
        <Tab eventKey="modules" title="Modules" style={{ maxWidth: "100%" }}>
          <div className="text-center pt-5">
            {" "}
            <h3>
              {course?.coursemodule
                ? sectionContent(course?.coursemodule)
                : "NA"}
            </h3>
          </div>
        </Tab>
        <Tab eventKey="grades" title="Grades" style={{ maxWidth: "100%" }}>
          <div
            className="row justify-content-center w-100 mx-0 my-5 linkssec"
            style={{ maxWidth: "100%" }}
          >
            <div className="col-12 quizzes shadow-lg bg-body rounded mb-5 m-lg-0">
              <div className="qzsdiv">
                <Card>
                  <CardHeader className="fs-5 fw-bold bg-primary pb-3 text-light">
                    {course?.name} Grading
                  </CardHeader>
                  <hr />
                  <CardBody className="bg-light">
                    <MDBDataTableV5
                      hover
                      paging={false}
                      responsive
                      striped
                      data={examsData}
                      bordered
                      searching={false}
                      style={{ fontSize: "13pt" }}
                    />
                  </CardBody>
                  {totMarks?.length > 0 ? (
                    <CardFooter>
                      <p className="fs-5 p-0 m-0">
                        Total Score:{" "}
                        <span className="fs-6 text-primary fw-bolder">
                          {totScores}
                        </span>{" "}
                        | Total Marks:{" "}
                        <span className="fs-6 text-primary fw-bolder">
                          {totMarks}
                        </span>
                      </p>
                      <h5 className="text-primary fw-bold p-0 m-0">
                        Percentage: {((totScores / totMarks) * 100).toFixed(2)}{" "}
                        %
                      </h5>
                    </CardFooter>
                  ) : (
                    ""
                  )}
                </Card>
              </div>
            </div>
          </div>
        </Tab>
        {/* <Tab eventKey="zoom" title="Zoom for BBA">
              <div className="text-center pt-5" style={{maxWidth: '100%'}}>

              </div>
            </Tab>
            <Tab eventKey="people" title="People">
              <div className="text-center pt-5" style={{maxWidth: '100%'}}>

              </div>
            </Tab> */}
        <Tab eventKey="srt" title="Student Rating of Teaching">
          <div className="text-center pt-5" style={{ maxWidth: "100%" }}></div>
        </Tab>
        {/* <Tab eventKey="lcp" title="Library Course Page">
              <div className="text-center pt-5" style={{maxWidth: '100%'}}>

              </div>
            </Tab> */}
        <Tab eventKey="helpandresourses" title="Help &amp; Resourses">
          <div className="text-center pt-5" style={{ maxWidth: "100%" }}>
            <h3>
              {course?.helpandresources
                ? sectionContent(course?.helpandresources)
                : "NA"}
            </h3>
          </div>
        </Tab>
        <Tab eventKey="googledrive" title="Google Drive">
          <div className="text-center pt-5" style={{ maxWidth: "100%" }}></div>
        </Tab>
        {/* <Tab eventKey="collaborations" title="Collaborations">
              <div className="text-center pt-5" style={{maxWidth: '100%'}}>

              </div>
            </Tab> */}
      </Tabs>
    );
  };

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content m-0 p-0">
        <div className="mt-3">
          <Link to="/course" className="btn btn-primary fs-6 fw-bold">
            <i className="now-ui-icons arrows-1_minimal-left"></i>&nbsp; Back
          </Link>
        </div>
        <div
          style={{ position: "absolute", maxWidth: "100%" }}
          className="text-center w-100 mx-0 mt-2 p-0 content"
        >
          <ControlledTabs />
        </div>
      </div>
    </>
  );
};

export default CourseGrading;
